import {
  AlertDto,
  GlobalAlertViewDto,
  MemberAlertViewDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const alertRequests = {
  getGlobalAlerts: EndpointDefinition.get<GlobalAlertViewDto, null>({
    name: 'getGlobalAlerts',
    route: '/notifications/alerts',
  }),
  getAlertsForMember: EndpointDefinition.get<
    MemberAlertViewDto,
    { memberId: string }
  >({
    name: 'getMemberAlerts',
    route: '/notifications/alerts/:memberId',
  }),
  getAlertsForMemberFeed: EndpointDefinition.get<
    MemberAlertViewDto,
    { memberId: string }
  >({
    name: 'getMemberFeedAlerts',
    route: '/notifications/alerts/:memberId/feed',
  }),
  deleteAlert: EndpointDefinition.delete<AlertDto, { alertId: number }>({
    name: 'deleteAlert',
    route: '/notifications/alerts/:alertId',
  }),
};
